import { render, staticRenderFns } from "./ModalUsuarioPro.vue?vue&type=template&id=2e55d211&scoped=true&"
import script from "./ModalUsuarioPro.vue?vue&type=script&lang=js&"
export * from "./ModalUsuarioPro.vue?vue&type=script&lang=js&"
import style0 from "./ModalUsuarioPro.vue?vue&type=style&index=0&id=2e55d211&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e55d211",
  null
  
)

export default component.exports